import type { ValueOf } from 'cpool-utils';

export const COMMUNICATION_PAGE_PATH = '/communication';

export const COMMUNICATION_SUB_TABS = {
    // Hidden with SubTabs; COMMUNICATION_SUB_TABS kept for its restore.
    // ATTACHMENTS: 'attachments',
    CHAT: 'chat',
    // EMAILS: 'emails',
} as const;

export type CommunicationSubTab = ValueOf<typeof COMMUNICATION_SUB_TABS>;
